<template>
    <div class="grid-container">
      <div class="grid-item p-ml-4 p-mr-3">
        <Chart type="pie" :data="chartData" :options="chartOptions" class="walking-speed-chart" />
        <Chart type="bar" :data="basicData" :options="basicOptions" class="walking-speed-chart" />
      </div>

      <div class="grid-item p-ml-4">
        <Chart type="doughnut" :data="chartData" :options="chartOptions" class="walking-speed-chart" />
        <Chart type="line" :data="basicData" class="walking-speed-chart" />
      </div>

      <div class="grid-item p-ml-4">
        <Chart type="polarArea" :data="chartData" :options="chartOptions" class="walking-speed-chart"/>
        <Chart type="bar" :data="basicData" :options="basicOptions" class="walking-speed-chart" />
      </div>
    </div>
  </template>
  
  <script>
  
  export default {
    data() {
      return {
      
        basicData: {
                labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
                datasets: [
                    {
                        label: 'My First dataset',
                        backgroundColor: '#42A5F5',
                        data: [65, 59, 80, 81, 56, 55, 40]
                    },
                    {
                        label: 'My Second dataset',
                        backgroundColor: '#FFA726',
                        data: [28, 48, 40, 19, 86, 27, 90]
                    }
                ]
            },
            basicOptions: {
                plugins: {
                    legend: {
                        labels: {
                            color: '#495057'
                        }
                    }
                }
            },
        chartData: {
				labels: ['A','B','C'],
				datasets: [
					{
						data: [300, 50, 100],
						backgroundColor: [
                            "#42A5F5",
                            "#66BB6A",
                            "#FFA726"
                        ],
                        hoverBackgroundColor: [
                            "#64B5F6",
                            "#81C784",
                            "#FFB74D"
                        ]
					}
				]
			},
			chartOptions: {
				legend: {
                    labels: {
                        fontColor: '#495057'
                    }
                }
			},
        checkRole:null,
        checkView_data:null,
        checkAdd_data:null,
        checkEdit_data:null,
        checkDelete_data:null,
  
  
        keyword: "",
        suggestion_receiveDate: null,
        suggestion_toDate: null,
        selectedSuggestion: null,
        suggestion_table: [],
        filters: {},
        temp: null,
        displayConfirmation: false,
        suggestionModal: false,
        selectedData: "",
        suggest_date: "",
        suggest_name: "",
        suggest_email_phone: "",
        suggest_topic: "",
        suggest_detail: "",
        suggest_reply: "",
        suggest_disable: true,
      };
    },
    watch: {
      suggestion_receiveDate(val) {
        if (val == null) {
          this.suggestion_toDate = null;
        }
      },
    },
    created() {
      this.initialData();
      this.checkRole = JSON.parse(localStorage.getItem("data")).permission_id;
      this.checkView_data = JSON.parse(localStorage.getItem("data")).view_data;
      this.checkAdd_data = JSON.parse(localStorage.getItem("data")).add_data;
      this.checkEdit_data = JSON.parse(localStorage.getItem("data")).edit_data;
      this.checkDelete_data = JSON.parse(localStorage.getItem("data")).delete_data;
    },
    mounted() {},
    methods: {
      async checkPermissionEdit(suggest_id) {
        if (this.suggest_disable == false) {
          this.suggestionModal = true;
          this.editData(suggest_id);
          this.temp = suggest_id;
        } else {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "เกิดข้อผิดพลาด",
          //   detail: "คุณไม่มีสิทธิ์ในการแก้ไขข้อมูล",
          //   life: 10000,
          // });
  
          this.$fire({
            title: "คุณไม่มีสิทธิ์ในการแก้ไขข้อมูล",
            // text: "คุณไม่มีสิทธิ์ในการแก้ไขข้อมูล",
            type: "warning",
            timer: 10000,
            confirmButtonColor: '#28B463',
          });
        }
      },
      async checkPermissionDelete(suggest_id) {
        if (this.suggest_disable == false) {
          this.displayConfirmation = true;
          this.temp = suggest_id
        } else {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "เกิดข้อผิดพลาด",
          //   detail: "คุณไม่มีสิทธิ์ในการลบข้อมูล",
          //   life: 10000,
          // });
           this.$fire({
            title: "คุณไม่มีสิทธิ์ในการลบข้อมูล",
            // text: "คุณไม่มีสิทธิ์ในการลบข้อมูล",
            type: "warning",
            timer: 10000,
            confirmButtonColor: '#28B463',
          });
        }
      },
      async initialData() {
        this.filters={}
        let temporary = localStorage.getItem("username");
        if ((temporary.toString().indexOf("manage03") != -1) || temporary.toString().indexOf("manage032") != -1) {
          this.suggest_disable = false;
        } else {
          this.suggest_disable = true;
        }
  
        await this.axios
          .post(`${this.$url_service}/get/suggestion`, {
            body: {
              topic: "get-table",
            },
          })
          .then((response) => {
            this.suggestion_table = response.data.data;
            // console.log("this.suggestion_table",this.suggestion_table)
            // แก้ไขเวลา
            // for (let index = 0; index < this.suggestion_table.length; index++) {
            //   const element = this.suggestion_table[index].date.split("/")
              
            //   let dateNew = new Date(`${element[1]}/${element[0]}/${element[2]}`)
            //   // console.log("dateNew",dateNew)
            //   this.suggestion_table[index].date = moment(dateNew).locale('th').add(543, 'year').format("l")
            // }
  
          });
      },
      async searchSuggest() {
        this.filters={}
        var start_date, to_date;
        if (this.suggestion_receiveDate != null) {
          const receive = new Date(this.suggestion_receiveDate);
          const ye1 = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
            receive
          );
          const mo1 = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
            receive
          );
          const da1 = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
            receive
          );
          start_date = `${ye1}-${mo1}-${da1}`;
        }
        if (this.suggestion_toDate != null) {
          const to = new Date(this.suggestion_toDate);
          const ye2 = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
            to
          );
          const mo2 = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
            to
          );
          const da2 = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
            to
          );
          to_date = `${ye2}-${mo2}-${da2}`;
        }
        await this.axios
          .post(`${this.$url_service}/get/suggestion`, {
            body: {
              topic: "search-table",
              keyword: this.keyword,
              receive_date: start_date,
              to_date: to_date,
            },
          })
          .then((response) => (this.suggestion_table = response.data.data));
      },
  
      async editData(data) {
        await this.axios
          .post(`${this.$url_service}/get/suggestion`, {
            body: {
              topic: "showone-suggestion",
              id: data,
            },
          })
          .then((response) => {
            (this.selectedData = response.data.data),
              (this.suggest_date = response.data.data.date),
              (this.suggest_name = response.data.data.suggest_name),
              (this.suggest_email_phone = response.data.data.suggest_contact),
              (this.suggest_topic = response.data.data.suggest_topic),
              (this.suggest_detail = response.data.data.suggest_detail),
              (this.suggest_reply = response.data.data.suggest_reply);
          });
      },
  
      async saveSuggestion() {
        await this.axios
          .post(
            `${this.$url_service}/get/suggestion?user=${this.getUsername()}`,
            {
              body: {
                topic: "edit-suggestion",
                id: this.temp,
                reply: this.suggest_reply,
                editor: JSON.parse(localStorage.getItem("data")).user_id,
              },
            }
          )
          .then(() => this.initialData());
        this.suggestionModal = false;
      },
  
      async confirmDelete(data) {
        await this.axios
          .post(
            `${this.$url_service}/get/suggestion?user=${this.getUsername()}`,
            {
              body: {
                topic: "delete-suggestion",
                id: this.temp,
              },
            }
          )
          .then(() => this.initialData());
        this.displayConfirmation = false;
        console.log(`Delete ${data} finish!`);
      },
  
      async clearSearchField() {
        this.filters={}
        await this.axios
          .post(`${this.$url_service}/get/suggestion`, {
            body: {
              topic: "get-table",
            },
          })
          .then((response) => {
            // console.log(response.data),
              (this.suggestion_table = response.data.data);
          });
        this.suggestion_receiveDate = null;
      },
    },
  };
  </script>
  
  <style scoped>
  .grid-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr); 
  gap: 5px;  
}

.grid-item {
  text-align: center; 
}
  .walking-speed-chart{
    /* margin-top: 20px; */
    height: 52%;
    width: 460px;
    margin: 5px
}
  
  </style>
  
  
  <style scoped lang="scss">
  @media screen and (min-width: 819px) and (max-width: 1200px)  {
    #Search{
        width: 20rem;
      }
  }
  @media screen and (max-width: 818px) {
      #Search{
        width: 100%;
      }
  }
    /deep/ .p-progressbar {
      height: .5rem;
      background-color: #D8DADC;
    
      .p-progressbar-value {
        background-color: #607D8B;
      }
    }
    
    .p-datatable .p-column-filter {
      display: none;
    }
    
    .table-header {
      display: flex;
      justify-content: space-between;
      min-width: 10rem;
      max-width: 15rem;
    }
    
    /deep/ .p-datatable.p-datatable-customers {
      .p-datatable-header {
        padding: 1rem;
        text-align: left;
        font-size: 1.5rem;
      }
    
      .p-paginator {
        padding: 1rem;
      }
    
      .p-datatable-thead > tr > th {
        text-align: left;
      }
    
      .p-datatable-tbody > tr > td {
        cursor: auto;
      }
    
      .p-dropdown-label:not(.p-placeholder) {
        text-transform: uppercase;
      }
    }
    
    /* Responsive */
    .p-datatable-customers .p-datatable-tbody > tr > td .p-column-title {
      display: none;
    }
    
    .customer-badge {
      border-radius: 2px;
      padding: .25em .5rem;
      text-transform: uppercase;
      font-weight: 700;
      font-size: 12px;
      letter-spacing: .3px;
    
      &.status-qualified {
        background: #C8E6C9;
        color: #256029;
      }
    
      &.status-unqualified {
        background: #FFCDD2;
        color: #C63737;
      }
    
      &.status-negotiation {
        background: #FEEDAF;
        color: #8A5340;
      }
    
      &.status-new {
        background: #B3E5FC;
        color: #23547B;
      }
    
      &.status-renewal {
        background: #ECCFFF;
        color: #694382;
      }
    
      &.status-proposal {
        background: #FFD8B2;
        color: #805B36;
      }
    }
    
    .p-progressbar-value.ui-widget-header {
      background: #607d8b;
    }
    
    @media (max-width: 640px) {
      .p-progressbar {
        margin-top: .5rem;
      }
    }
    
    .product-image {
      width: 100px;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)
    }
    
    .orders-subtable {
      padding: 1rem;
    }
    
    .product-badge {
      border-radius: 2px;
      padding: .25em .5rem;
      text-transform: uppercase;
      font-weight: 700;
      font-size: 12px;
      letter-spacing: .3px;
    
      &.status-instock {
        background: #C8E6C9;
        color: #256029;
      }
    
      &.status-outofstock {
        background: #FFCDD2;
        color: #C63737;
      }
    
      &.status-lowstock {
        background: #FEEDAF;
        color: #8A5340;
      }
    }
    
    .order-badge {
      border-radius: 2px;
      padding: .25em .5rem;
      text-transform: uppercase;
      font-weight: 700;
      font-size: 12px;
      letter-spacing: .3px;
    
      &.order-delivered {
        background: #C8E6C9;
        color: #256029;
      }
    
      &.order-cancelled {
        background: #FFCDD2;
        color: #C63737;
      }
    
      &.order-pending {
        background: #FEEDAF;
        color: #8A5340;
      }
    
      &.order-returned {
        background: #ECCFFF;
        color: #694382;
      }
    }
    
    @media screen and (max-width: 960px) {
      /deep/ .p-datatable {
        &.p-datatable-customers {
          .p-datatable-thead > tr > th,
          .p-datatable-tfoot > tr > td {
            display: none !important;
          }
    
          .p-datatable-tbody > tr {
            border-bottom: 1px solid var(--layer-2);
    
            > td {
              text-align: left;
              display: block;
              border: 0 none !important;
              width: 100% !important;
              float: left;
              clear: left;
              border: 0 none;
    
              .p-column-title {
                padding: .4rem;
                min-width: 30%;
                display: inline-block;
                margin: -.4rem 1rem -.4rem -.4rem;
                font-weight: bold;
              }
    
              .p-progressbar {
                margin-top: .5rem;
              }
            }
          }
        }
      }
    }
    </style>
    
  